// GEL BÊTA le 07/10/2026. Voir docs/GEL_BETA.md.
// Architecture figée : paiement dual, Coco via settings, rôles user_roles/has_role, âge 18 soft, pas de Connect.
// Porte ouverte : corrections de retours testeurs uniquement sur ordre Hiti, lot unique, sans rouvrir ces règles.
// Interdit sans Hiti : tama-wip→main, édition client.ts / types.ts / .env / config.toml / previewAuthStorage.
import { createContext, useContext } from "react";
import { deckEngine } from "./deckEngine";
import type { PlaybackEngineApi } from "./engineApi";

/**
 * Moteur de lecture fourni au composant d'interface par son conteneur.
 *
 * Le deck 3 cartes est désormais le seul moteur de Tama : il est donc la
 * valeur par défaut du contexte.
 */
export const PlaybackEngineContext = createContext<PlaybackEngineApi>(deckEngine);

export function usePlaybackEngine(): PlaybackEngineApi {
  return useContext(PlaybackEngineContext);
}
